import { State } from "src/commands/UpdateStateCommand"

export type PrintMessageCommands =
	| "push_status"
	| "ams_control"
	| State
	| "gcode_line"
	| "gcode_file"
	| "project_file"

export type PrintMessageCommand = {
	command: PrintMessageCommands
	param?: string
	sequence_id: string
}

export interface PrintMessage {
	print: PrintMessageCommand
}

export function isPrintMessage(data: any): data is PrintMessage {
	return (
		!!data?.print &&
		!!data?.print?.command &&
		["push_status", "resume", "gcode_line", "gcode_file", "project_file", "ams_filament_setting"].includes(
			data.print.command
		)
	)
}
